var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flag flag-icon",class:_vm.className,attrs:{"alt":_vm.country,"title":_vm.country}})}
var staticRenderFns = []

export { render, staticRenderFns }